<template>
  <div class="start">
    <img
      class="bg"
      src="https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/496df492e12d48ef18c0f72b1ad3183f.png"
      alt=""
    />
    <div class="tips">*问卷信息仅用于为个人定制营养方案，建议每周评估一次</div>
    <div class="btn" @click="bindClick">开始评估</div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      res: null
    }
  },
  created() {
    this.init()
  },
  methods: {
    bindClick() {
      if (this.res && this.res.code == 200) {
        this.$router.replace({
          path: '/cna-question-v2/question',
          query: this.$route.query
        })
      } else if (this.res && this.res.code == 412) {
        if (this.$route.query.no_recipe) {
          this.$dialog
            .confirm({
              title: '提示',
              message: '问卷已填写'
            })
            .then(() => {})
            .catch(() => {})
          return
        }
        this.$dialog
          .confirm({
            title: '提示',
            message: '问卷已使用，是否直接查看结果？'
          })
          .then(() => {
            this.$router.replace({
              path: '/cna-question-v2/result',
              query: this.$route.query
            })
          })
          .catch(() => {
            // on cancel
          })
      } else {
        this.$toast((this.res && this.res.msg) || '异常错误')
      }
    },
    init() {
      let params = {
        cna_new_id: this.$route.query.id,
        que_id: this.$route.query.queId
      }
      this.$http
        .getBaseApp('que/CnaV2/initCna', params)
        .then((res) => {
          res = res.data
          this.res = res
        })
        .catch(() => {})
    }
  }
}
</script>
<style lang="scss" scoped>
.start {
  min-height: 100vh;
  position: relative;

  .bg {
    width: 100%;
    height: auto;
  }

  .tips {
    position: absolute;
    width: 100%;
    left: 50%;
    transform: translate(-50%, 0%);
    top: 682px;
    text-align: center;
    font-size: 10px;
    font-family: PingFangSC-Regular, PingFang SC;
    color: rgba(0, 0, 0, 0.4);
    line-height: 18px;
  }

  .btn {
    position: fixed;
    left: 50%;
    bottom: 46px;
    transform: translate(-50%, 0%);
    width: 271px;
    height: 50px;
    background: #6759ff;
    border-radius: 25px;
    font-size: 20px;
    text-align: center;
    font-family: Alibaba-PuHuiTi-M, Alibaba-PuHuiTi;
    color: #ffffff;
    line-height: 50px;
  }
}
</style>
